import { render } from "./DashboardDaeduck.vue?vue&type=template&id=08272bf0&scoped=true"
import script from "./DashboardDaeduck.vue?vue&type=script&lang=js"
export * from "./DashboardDaeduck.vue?vue&type=script&lang=js"

import "./DashboardDaeduck.vue?vue&type=style&index=0&id=08272bf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08272bf0"]])

export default __exports__